// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5976":"1af466bd","8448":"900dc876"}[chunkId] + ".chunk.css";
};